export const getBudgetColor = (spent, total, threshold = 90) => {
  const calculatedTotal = total === 0 ? 1 : total;
  const usagePercentage = (spent / calculatedTotal) * 100;

  if (spent >= calculatedTotal) return "#C70000"; // Red
  if (usagePercentage >= threshold) return "#FF9494"; // Salmon
  return "#83B50D"; // Green
};

export const getBudgetOverallColor = (spent, total, threshold = 90) => {
  const calculatedTotal = total === 0 ? 1 : total;
  const usagePercentage = (spent / calculatedTotal) * 100;

  if (spent >= calculatedTotal) return "#C70000"; // Red
  if (usagePercentage >= threshold) return "#FF9494"; // Salmon
  return "#83B50D"; // Green
};

export const getCreditGuardianColor = (spent, total) => {
  const calculatedTotal = total === 0 ? 1 : total;
  const usagePercentage = (spent / calculatedTotal) * 100;
  if (usagePercentage >= 30) {
    return "#FF9494";
  }

  return "#83B50D";
};

export const getHeavyHittersColor = (
  spent,
  total,
  threshold = 1,
  trend = "",
) => {
  const normalizedTrend = String(trend).toLowerCase();

  if (normalizedTrend === "up") {
    return "#FF9494";
  }
  return "#83B50D";
};
